<template>
    <div :class="topbarClass">
        <button class="p-link layout-menu-button" @click="onMenuToggle">
            <span class="pi pi-bars"></span>
        </button>
        <div class="layout-topbar-icons">
            <!-- <button class="p-link">
                <span class="layout-topbar-item-text">Notifications</span>
                <span class="layout-topbar-icon pi pi-inbox"></span>
                <span class="layout-topbar-badge">5</span>
            </button> -->
            <button @click="onLogout" class="p-link">
                <span class="layout-topbar-item-text">Logout</span>
                <span class="layout-topbar-icon pi pi-sign-out"></span>
            </button>
            <!--
            <button class="p-link">
                <span class="layout-topbar-item-text">Profile</span>
                <span class="layout-topbar-icon pi pi-user"></span>
            </button>
            -->
        </div>
    </div>
</template>

<script>
    import router from "./router";
    
    export default {
        computed:{
            topbarClass() {
                return ['layout-topbar', {
                    'layout-topbar-dark': this.$store.state.theme === 'dark',
                    'layout-topbar-light': this.$store.state.theme === 'light'
                }];
            },
        },
        methods: {
            onMenuToggle(event) {
                this.$emit('menu-toggle', event);
            },
            onLogout() {
                localStorage.removeItem("token");
                localStorage.removeItem("user_info");
                router.push("/login");
            }
        }
    }
</script>